import React from 'react'
import styles from './StoreList.module.css'
import height from './height.module.css'

export default function Address(props) {
  return (
    <div className="container">
      <div className={`row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 ${height.address}`}>
        <p className="col mx-auto">{props.address.addressLine1},<br />{props.address.addressLine2},<br />{props.address.addressLine3},<br />{props.address.postcode}</p>
        <div className={`col mx-auto ${styles.threeWords} righttext`}>
          <a href={`https://what3words.com/${props.threeWords}`}>
            <div><span className={`${styles.threeWordsLogo}`}>///</span>{props.threeWords}</div>
          </a>
        </div>
      </div>
    </div>
  )
}
